import { ReactNode, useEffect, useState } from 'react';
import { format } from 'date-fns';
import { CheckCircleIcon, ExclamationTriangleIcon } from '../atoms';

interface ContainerProps {
  children: ReactNode;
}

const Container = ({ children }: ContainerProps) => {
  return <div className="flex items-center gap-1 overflow-hidden">{children}</div>;
};

interface ConnectionIndicatorProps {
  lastCommunication: number | null;
  title?: string;
}

export const ConnectionIndicator = ({ lastCommunication, title = 'Autosaved' }: ConnectionIndicatorProps) => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

  useEffect(() => {
    const handleConnectionChange = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener('online', handleConnectionChange);
    window.addEventListener('offline', handleConnectionChange);

    return () => {
      window.removeEventListener('online', handleConnectionChange);
      window.removeEventListener('offline', handleConnectionChange);
    };
  }, []);

  if (!isOnline) {
    return (
      <Container>
        <ExclamationTriangleIcon className="h-[16px] w-[16px] shrink-0" />
        <span className="text-fletchers-red-500 overflow-hidden text-[0.75rem] font-normal text-ellipsis whitespace-nowrap">
          Internet connection lost
        </span>
      </Container>
    );
  }

  return (
    <>
      {!!lastCommunication && isOnline && (
        <Container>
          <CheckCircleIcon className="h-[16px] w-[16px] shrink-0" />
          <span className="text-fletchers-gray-200 overflow-hidden text-[0.75rem] font-normal text-ellipsis whitespace-nowrap">
            {`${title}: ${format(new Date(lastCommunication), 'HH:mm d MMM y')}`}
          </span>
        </Container>
      )}
    </>
  );
};
